import {Grid, Typography} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import React from "react";

const EstimatedTimeIcon = ({
                               totalTime
                           }) => {
    return (
        <Grid item container alignItems="center" spacing={0.25} sx={{width: "auto"}}>
            <Grid item>
                <AccessTimeIcon fontSize="small" sx={{color: "#707070"}}/>
            </Grid>
            <Grid item>
                <Typography sx={{fontSize: 13, color: "#bdbdbd"}}>
                    {totalTime} min
                </Typography>
            </Grid>
        </Grid>
    );
};
export default EstimatedTimeIcon;